module.exports = __webpack_public_path__ + "static/capture3-3af7ee1bcab2a0a206593728c3e24fcb.png";